export default __webpack_public_path__ + "static/media/intro-1.a4346af8.jpg";